<p-dialog
  [(visible)]="visible"
  styleClass="cardapio-dialog tilt-in-top-1"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [focusOnShow]="false"
  [blockScroll]="true"
  [showHeader]="false"
  [style]="{ width: 'min(600px, 96vw)' }"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
>
  <div class="pod-wrap" *ngIf="produto && form">
    <!-- Botao voltar -->
    <button class="modal-back-btn" type="button" (click)="onDialogHide()">
      <i class="pi pi-arrow-left"></i>
    </button>
    <!-- HERO -->
    <div class="hero" *ngIf="produto.foto">
      <img [src]="produto.foto" [alt]="produto.nome" />
      <span class="id-badge">#{{ padId(produto.id) }}</span>
    </div>

    <!-- TITULO / PRECO -->
    <div class="head">
      <div>
        <h2 class="name">{{ produto.nome }}</h2>
        <p class="desc" *ngIf="produto.descricao">{{ produto.descricao }}</p>
      </div>
      <div class="price">{{ formatarPreco(produto.precoPromocional || produto.preco) }}</div>
    </div>

    <!-- OPCOES -->
    <div class="body-scroll" [formGroup]="form" #bodyScroll>
      <!-- Abre um por vez -->
      <p-accordion [(activeIndex)]="activeIndex" [multiple]="false">
        <p-accordionTab
          *ngFor="let g of grupos; let i = index; trackBy: trackByGrupo"
          [header]="optionHeader(g)"
          (onOpen)="activeIndex = i"
        >
          <div class="hint" *ngIf="optionHint(g)">{{ optionHint(g) }}</div>

          <!-- RADIO -->
          <div *ngIf="g.tipo === 'radio'" class="group radio">
            <div *ngFor="let o of g.opcoes; trackBy: trackByOpcao" class="row">
              <div class="left">
                <p-radioButton
                  [name]="g.titulo"
                  [value]="o.titulo"
                  [inputId]="g.titulo + '-' + o.titulo"
                  [formControl]="getControl(g.titulo)"
                  (onClick)="onRadioPicked(g, i)"
                ></p-radioButton>
                <label [for]="g.titulo + '-' + o.titulo">{{ o.titulo }}</label>
              </div>
              <div class="right">
                <span class="price-add" *ngIf="o.valor > 0">+ {{ formatarPreco(o.valor) }}</span>
              </div>
            </div>

            <div class="err" *ngIf="getControl(g.titulo).invalid && getControl(g.titulo).touched">
              {{ 'cardapio_digital.selecione_opcao' | translate }}
            </div>
          </div>

          <!-- CHECKBOX -->
          <div *ngIf="g.tipo === 'checkbox'" class="group checkbox" [formGroup]="getGroup(g.titulo)">
            <div *ngFor="let o of g.opcoes; trackBy: trackByOpcao" class="row">
              <div class="left">
                <p-checkbox
                  [binary]="true"
                  [formControlName]="o.titulo"
                  [disabled]="checkboxDisabled(g, o.titulo)"
                  (onChange)="onCheckboxChanged(g, i)"
                ></p-checkbox>
                <span class="label">{{ o.titulo }}</span>
              </div>
              <div class="right">
                <span class="price-add" *ngIf="o.valor > 0">+ {{ formatarPreco(o.valor) }}</span>
              </div>
            </div>

            <div class="err" *ngIf="getGroup(g.titulo).invalid && getGroup(g.titulo).touched">
              {{ checkboxErrorText(g) }}
            </div>
          </div>

          <!-- CONTADOR -->
          <div *ngIf="g.tipo === 'contador'" class="group counter" [formGroup]="getGroup(g.titulo)">
            <div *ngFor="let o of g.opcoes; trackBy: trackByOpcao" class="row row-counter">
              <div class="left left-col">
                <span class="label">{{ o.titulo }}</span>
                <small class="price-under" *ngIf="o.valor > 0">+ {{ formatarPreco(o.valor) }}</small>
              </div>
              <div class="right right-col">
                <p-inputNumber
                  [showButtons]="true"
                  [min]="0"
                  [max]="counterMax(g, o.titulo)"
                  [formControlName]="o.titulo"
                  (onInput)="onCounterChanged(g, i)"
                  (onBlur)="onCounterChanged(g, i)"
                ></p-inputNumber>
              </div>
            </div>

            <div class="err" *ngIf="getGroup(g.titulo).invalid && getGroup(g.titulo).touched">
              {{ counterErrorText(g) }}
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>

      <!-- Comentarios -->
      <div class="comments">
        <textarea
          pInputTextarea
          [autoResize]="false"
          rows="5"
          [placeholder]="'cardapio_digital.comentarios_placeholder' | translate"
          [formControl]="comentarios"
          class="no-horizontal-scroll"
        ></textarea>
      </div>
    </div>
  </div>

  <!-- FOOTER REAL -->
  <ng-template pTemplate="footer">
    <div class="pod-footer">
      <div class="qty">
        <button pButton icon="pi pi-minus" class="qty-btn" (click)="dec()" [disabled]="cantidad <= 1"></button>
        <span class="q">{{ cantidad }}</span>
        <button pButton icon="pi pi-plus" class="qty-btn" (click)="inc()"></button>
      </div>

      <button
        pButton
        class="cta"
        icon="pi pi-shopping-cart"
        [label]="('cardapio_digital.adicionar' | translate) + ' ' + formatarPreco(subtotal() * cantidad)"
        [disabled]="!canSubmit"
        (click)="agregarAlPedido()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
